import InstructionsStep from './instructions/step';
import ResourcesStep from './resources/step';
import GroupStep from './group/step';
import SubmissionStep from './submission/step';
import GalleryParticipationStep from './gallery-participation/step';
import ForumParticipationStep from './forum-participation/step';
import PeerAssessmentStep from './peer-assessment/step';

export default {
  data: {
    coursework: null,
    user_preferences: null,
    steps: []
  },

  components: {
    InstructionsStep,
    ResourcesStep,
    GroupStep,
    SubmissionStep,
    GalleryParticipationStep,
    ForumParticipationStep,
    PeerAssessmentStep,
  },

  computed: {
    sidebarStatusClass() {
      if (!this.coursework.is_completed && this.coursework.is_active) {
        return 'cwk-panel--in-progress';
      } else if (this.coursework.is_draft || this.coursework.is_upcoming) {
        return 'cwk-panel--upcoming';
      } else if (!this.coursework.is_completed && this.coursework.is_ended) {
        return 'cwk-panel--past-due';
      } else if (this.coursework.is_completed) {
        return 'cwk-panel--completed';
      }
    },
  },

  methods: {
    bindData(coursework, user_preferences = null) {
      this.coursework = Object.assign({}, coursework, { is_submitting: false });

      if (user_preferences)
        this.user_preferences = user_preferences;
    },

    getCoursework() {
      return Kadenze.Ajax.get({
        routeName: 'course_coursework',
        routeParams: [this.coursework.course_id, this.coursework.id],
        done: this.bindData,
      });
    },

    goToStep(step) {
      const elementRect = step.$el.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);

      $('html, body').animate({ scrollTop: middle }, 700);
    },

    setCurrentStep() {
      this.steps.filter(step => this.isVisible(step)).forEach(step => {
        this.steps.forEach(s => s.isInView = false);
        step.isInView = true;
      });
    },

    isVisible(step) {
      return step.isVisible && (
        step.number === 1 ?
          Kadenze.UIUtil.isInView(step.$el) :
          Kadenze.UIUtil.isInFullView(step.$el)
        );
    },
  },

  mounted() {
    this.steps
      .filter(step => step.isVisible)
      .forEach((step, idx) => step.number = idx + 1);

    Kadenze.UIUtil.initExpandableText();

    $(window).off('scroll.coursework_detail')
      .on('scroll.coursework_detail', () => this.setCurrentStep());

    this.setCurrentStep();
  },

  created() {
    this.steps = [];
  },
};
